module.exports = __webpack_public_path__ + "static/img/payment-tip.c5a95cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/common/img/payment-tip.png
// module id = 4ZNY
// module chunks = 37